import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles } from 'lucide-react';
const packItems = [{
  name: 'Guía práctica de 30 días',
  description: 'El paso a paso exacto para ordenar tus finanzas'
}, {
  name: 'Diario de Dinero en Acción',
  description: 'Ejercicios prácticos para cambiar tu mentalidad'
}, {
  name: 'Plan para Salir de Deudas',
  description: 'Estrategia probada para eliminar deudas nocivas'
}, {
  name: 'Comienza tu Ahorro con Propósito',
  description: 'Sistema simple para empezar a guardar dinero'
}, {
  name: 'Dinero en Pareja y Familia',
  description: 'Cómo hablar de dinero sin pelear'
}, {
  name: 'Obtén Ingresos Extra',
  description: 'Ideas rápidas para generar flujo de efectivo'
}, {
  name: 'Mentalidad y Afirmaciones',
  description: 'Reprograma tu mente para la abundancia'
}, {
  name: 'BONUS: Plantillas de Presupuesto',
  description: 'Excel y PDF listos para usar',
  isBonus: true
}, {
  name: 'BONUS: Guía de Apps Financieras',
  description: 'Las mejores herramientas digitales',
  isBonus: true
}];
const coverImages = ['https://cdn.magicpatterns.com/uploads/rEbP9cdsB5wKXX71QsCx5Z/portada_finanzas_faciles.png', 'https://cdn.magicpatterns.com/uploads/skbL3ibVy7bjUqX578naJR/portada_bono_4.png', 'https://cdn.magicpatterns.com/uploads/aqaWhvwqXbR7suvdSC7kHY/portada_bono2.png', 'https://cdn.magicpatterns.com/uploads/mXmUYZXmhYUCQtpTiNT7mX/portada_bono3.png', 'https://cdn.magicpatterns.com/uploads/82pjW85xD7qLnv8WLUSVLA/portada_bono1.png', 'https://cdn.magicpatterns.com/uploads/iowyRuUA8sVcfFG7ZcY8wE/portada_bono_5.png', 'https://cdn.magicpatterns.com/uploads/dsMDdhavFW6Br34VYUL9Sg/portada_bono_6.png', 'https://cdn.magicpatterns.com/uploads/s964ikNDhdyELhuCBkB5bQ/promocion_finanzas_faciles_1024x1536.png'];
export function OfferSection() {
  return <section id="oferta" className="py-20 bg-white" data-id="element-602">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-603">
        <div className="text-center mb-12" data-id="element-604">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#1e3a5f] mb-4" data-id="element-605">
            Todo lo que incluye el Pack Premium
          </h2>
          <p className="text-lg text-gray-600" data-id="element-606">
            Una colección completa de herramientas para tu libertad financiera
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-607">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mb-8" data-id="element-608">
            {coverImages.map((image, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.8,
            y: 20
          }} whileInView={{
            opacity: 1,
            scale: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative group" data-id="element-609">
                <img src={image} alt={`Portada ${index + 1}`} className="w-full rounded-lg shadow-xl group-hover:scale-105 group-hover:shadow-2xl transition-all duration-300" data-id="element-610" />
                <div className="absolute inset-0 bg-[#1e3a5f] opacity-0 group-hover:opacity-10 rounded-lg transition-opacity duration-300" data-id="element-611"></div>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-612">
          <div className="bg-[#1e3a5f] text-white p-6 text-center" data-id="element-613">
            <span className="bg-[#d4a574] text-[#1e3a5f] font-bold px-4 py-1 rounded-full uppercase text-sm tracking-wider inline-block mb-2" data-id="element-614">
              Contenido Exclusivo
            </span>
            <p className="text-[#f4e4d7]" data-id="element-615">
              Diseñado específicamente para mujeres emprendedoras
            </p>
          </div>

          <div className="p-8 md:p-12 bg-gray-50" data-id="element-616">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-617">
              {packItems.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-618">
                  <div className={`mt-1 p-1 rounded-full ${item.isBonus ? 'bg-[#d4a574]/20' : 'bg-green-100'}`} data-id="element-619">
                    <Check className={`w-4 h-4 ${item.isBonus ? 'text-[#d4a574]' : 'text-green-600'}`} data-id="element-620" />
                  </div>
                  <div data-id="element-621">
                    <h4 className={`font-semibold ${item.isBonus ? 'text-[#1e3a5f]' : 'text-gray-900'}`} data-id="element-622">
                      {item.isBonus && <span className="text-[#d4a574] mr-1" data-id="element-623">BONUS:</span>}
                      {item.name}
                    </h4>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-624">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200 text-center" data-id="element-625">
              <div className="inline-flex items-center gap-2 text-[#1e3a5f] font-medium bg-white px-6 py-3 rounded-full shadow-sm border border-gray-100" data-id="element-626">
                <Sparkles className="w-5 h-5 text-[#d4a574]" data-id="element-627" />
                <span data-id="element-628">Acceso inmediato y de por vida a todo el contenido</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}